import BaseGrid from 'components/atoms/base-grid';
import {
  ProviderDashboardFilters,
  ProviderDashboardHeader,
  ProviderDashboardProvidersTab,
  ProviderDashboardSummaryTab,
} from 'components/organisms/provider-dashboard';
import React from 'react';
import { useProviderDashboardFilters } from 'infrastructure/hooks/provider-dashboard/use-provider-dashboard-filters';
import { useProviderDashboardTab } from 'infrastructure/hooks/provider-dashboard/use-provider-dashboard-tab';

export const ProviderDashboard: React.FC = () => {
  const {
    activeTab,
    onTabChange,
    providersPage,
    providersPageSize,
    onPageChange,
  } = useProviderDashboardTab();

  const {
    selectedMonth,
    dateRange,
    clinicGuid,
    parentClinicGuid,
    providerGuid,
    filterCount,
    onMonthChange,
    onClinicChange,
    onProviderChange,
    onReset,
  } = useProviderDashboardFilters();

  React.useEffect(() => {
    if (activeTab === 'providers') {
      onPageChange(1);
    }
  }, [
    activeTab,
    clinicGuid,
    parentClinicGuid,
    providerGuid,
    selectedMonth,
    onPageChange,
  ]);

  return (
    <>
      <ProviderDashboardHeader
        activeTab={activeTab}
        onTabChange={onTabChange}
      />

      <BaseGrid rowGap={24}>
        <ProviderDashboardFilters
          selectedMonth={selectedMonth}
          onMonthChange={onMonthChange}
          clinicGuid={clinicGuid}
          parentClinicGuid={parentClinicGuid}
          onClinicChange={onClinicChange}
          filterCount={filterCount}
          providerGuid={providerGuid}
          onProviderChange={onProviderChange}
          onReset={onReset}
        />

        {activeTab === 'summary' ? (
          <ProviderDashboardSummaryTab
            dateRange={dateRange}
            clinicGuid={clinicGuid}
            parentClinicGuid={parentClinicGuid}
            providerGuid={providerGuid}
          />
        ) : (
          <ProviderDashboardProvidersTab
            page={providersPage}
            pageSize={providersPageSize}
            onPageChange={onPageChange}
            dateRange={dateRange}
            clinicGuid={clinicGuid}
            parentClinicGuid={parentClinicGuid}
            providerGuid={providerGuid}
          />
        )}
      </BaseGrid>
    </>
  );
};
